import type { DemoRole } from '@infoscend-claims/shared';

export function homeRouteFor(role: DemoRole): string {
  switch (role) {
    case 'brand_approver': return '/approver';
    case 'brand_admin':    return '/admin/schemes';
    case 'distributor_submitter': return '/';
  }
}
